import {GET_DATA_EMAIL, GET_DATA_NEW_PLANTEMPLATE, SET_DATA_NEW_PLANTEMPLATE} from '../actions/actionTypes'
import {RequertNewPlanTemplateFaileAction, GetDataNewPlanTemplateSuccessAction, IsResultAction, RequertDataEmailAction, GetDataEmailSuccessAction } from '../actions'

import { put, takeLatest} from 'redux-saga/effects'
import { Api } from './api'

function* GetDataNew(action){
    try{
        const DataNew = yield Api.GetDataNewFromApi(action.id);
        yield put(GetDataNewPlanTemplateSuccessAction(DataNew))
    }catch(error){
        yield put(RequertNewPlanTemplateFaileAction(error))
    }
}
export function* watchGetDataNew(){
    yield takeLatest(GET_DATA_NEW_PLANTEMPLATE, GetDataNew)
}

function* SetDataNew(action){
    try{
        const isResult = yield Api.SetDataNewFromApi(action.DataNew);
        if(isResult)
        {
            yield put(IsResultAction(isResult))
        }
        else
        {
            yield put(RequertNewPlanTemplateFaileAction("error"))
        }
    }catch(error){
        yield put(RequertNewPlanTemplateFaileAction(error))
    }
}
export function* watchSetDataNew(){
    yield takeLatest(SET_DATA_NEW_PLANTEMPLATE, SetDataNew)
}
function* GetDataEmail(){
    try{
        const DataEmail = yield Api.GetDataEmailFromApi();
        yield put(GetDataEmailSuccessAction(DataEmail))
    }catch(error){
        yield put(RequertDataEmailAction(error))
    }
}
export function* watchGetDataEmail(){
    yield takeLatest(GET_DATA_EMAIL, GetDataEmail);
}